import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import CloseIcon from '../../layouts/SVG/CloseIcon';

const SendScheduleConfirmModel = ({ show, onClose, mode, handleScheduleLater, handleSendNow }) => {
  return (
    <Modal show={show} className="modal-delete" onHide={onClose} animation={true} centered>
      <Modal.Body>
        <CloseIcon handleModalClose={onClose} />
        <i className="fa fas fa-exclamation-triangle fa-warning" />
        <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
          {mode === 'schedule_later' ? 'Scheduled Later ' : mode === 'send_now' ? 'Send Now ' : ''}
          Campaign Confirmation
        </Modal.Title>
        <Form.Text>
          Do you want to proceed{' '}
          <strong>
            {mode === 'schedule_later'
              ? 'Scheduled Later '
              : mode === 'send_now'
              ? 'Send Now '
              : ''}
          </strong>
          Campaign?
        </Form.Text>
        <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
          <Button
            variant="primary"
            style={{ minWidth: 160 }}
            onClick={mode === 'schedule_later' ? handleScheduleLater : handleSendNow}
          >
            Yes
          </Button>
          <Button variant="danger" style={{ minWidth: 160 }} onClick={onClose}>
            No
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(SendScheduleConfirmModel);
